module.exports = __webpack_public_path__ + "static/media/Valk5.b5ca6343.png";